import type {ReactiveController, ReactiveControllerHost} from 'lit';
import {type AvailableLanguages, getLanguage} from "../../utils/i18n";

export class LangAwareController implements ReactiveController {
    host: ReactiveControllerHost & Element;

    lang: AvailableLanguages;
    observer: MutationObserver | undefined;

    constructor(host: ReactiveControllerHost & Element) {
        (this.host = host).addController(this);
        this.lang = getLanguage(host);
    }

    checkLanguage = () => {
        const lang = getLanguage(this.host);
        if (this.lang !== lang) {
            this.lang = lang;
            this.host.requestUpdate();
        }
    }

    hostConnected() {
        this.checkLanguage()
        this.observer = new MutationObserver(this.checkLanguage)
        this.observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['lang'],
            subtree: true
        })
        window.addEventListener('languagechange', this.checkLanguage)
    }

    hostDisconnected() {
        this.observer?.disconnect();
        this.observer = undefined;
        window.removeEventListener('languagechange', this.checkLanguage)
    }
}
